import CreateUpdate from './CreateUpdate';

export default { CreateUpdate };
